import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from '@angular/forms';

@Component({
  selector: 'material-picker',
  templateUrl: './material-picker.component.html',
  styleUrls: ['./material-picker.component.scss']
})
export class MaterialPickerComponent implements OnInit {
  materialOptions: String[];
  laminateOptions: ['Ja, blinkend'];
  materialForm: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.materialForm = this.initMaterialForm();
    this.materialOptions = ['Monomeer'];
    this.laminateOptions = ['Ja, blinkend'];
  }

  initMaterialForm(): UntypedFormGroup {
    return this.formBuilder.group({
      material: new UntypedFormControl('', Validators.required),
      laminate: new UntypedFormControl('', Validators.required)
    });
  }

  laminateChange(event) {}

  materialChange(event) {}
}
